export const DEFAULT_APP_BRAND = "#015B9A";
export const APP_BRAND_STORAGE_KEY = "billsarthi_primary_color_v1";
export const APP_BRAND_EVENT = "billsarthi:brand-change";

export const normalizeBrandColor = (value) => {
  const normalized = String(value || "").trim().toUpperCase();
  return /^#[0-9A-F]{6}$/.test(normalized) ? normalized : DEFAULT_APP_BRAND;
};

const hexToRgb = (hex) => {
  const safe = normalizeBrandColor(hex).slice(1);
  return {
    r: parseInt(safe.slice(0, 2), 16),
    g: parseInt(safe.slice(2, 4), 16),
    b: parseInt(safe.slice(4, 6), 16),
  };
};

const mix = (hex, target, amount) => {
  const source = hexToRgb(hex);
  const result = ["r", "g", "b"].map((key) =>
    Math.round(source[key] + (target - source[key]) * amount)
      .toString(16)
      .padStart(2, "0")
  );
  return `#${result.join("")}`.toUpperCase();
};

export const readAppBrand = () => {
  if (typeof window === "undefined") return DEFAULT_APP_BRAND;
  return normalizeBrandColor(window.localStorage.getItem(APP_BRAND_STORAGE_KEY));
};

export const applyAppBrand = (value = readAppBrand()) => {
  if (typeof document === "undefined") return DEFAULT_APP_BRAND;
  const color = normalizeBrandColor(value);
  const { r, g, b } = hexToRgb(color);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  const root = document.documentElement.style;
  root.setProperty("--app-primary", color);
  root.setProperty("--app-primary-hover", mix(color, luminance > 0.55 ? 0 : 255, 0.16));
  root.setProperty("--app-primary-dark", mix(color, 0, 0.28));
  root.setProperty("--app-primary-soft", mix(color, 255, 0.86));
  root.setProperty("--app-primary-rgb", `${r}, ${g}, ${b}`);
  root.setProperty("--app-on-primary", luminance > 0.62 ? "#0F172A" : "#FFFFFF");
  return color;
};

export const saveAppBrand = (value) => {
  const color = normalizeBrandColor(value);
  window.localStorage.setItem(APP_BRAND_STORAGE_KEY, color);
  applyAppBrand(color);
  window.dispatchEvent(new CustomEvent(APP_BRAND_EVENT, { detail: { color } }));
  return color;
};
